// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___3qePk","opacScreen":"styles-module__opacScreen___37mVf","tray":"styles-module__tray___uMaGI"};